import React from 'react';

interface LogoProps {
  className?: string;
}

export function Logo({ className = "text-xl" }: LogoProps) {
  return (
    <div className={`font-black tracking-tighter flex items-center ${className}`}>
      <span className="text-white">Fest</span>
      <span className="text-[#4C3AFA]">in</span>
      <span className="text-[#FF5C00]">.</span>
    </div>
  );
}
